import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { securityApiClient } from "./common/apiClient";
import Config from "./common/Config";
import AppConfig from "./common/AppConfig";
import "./loginStyle.scss";
import InputTextField from "./components/textField/InputTextField";
import Button from "./components/button/Button";
import logo from "./images/siteLogo.png";
import { Link, useNavigate } from "react-router-dom";
import { Alert } from "@mui/material";
import { UserContext } from "./App";

export default function Login({ setToken }) {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [showInvalid, setShowInvalid] = useState(false);
  const [showLoginFailure, setShowLoginFailure] = useState(false);
  const { setUser } = useContext(UserContext);

  const [authError, setAuthError] = useState();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowInvalid(false);
    setShowLoginFailure(false);

    if (!username || !password) {
      setShowInvalid(true);
      return false;
    }

    const data = await loginUser({ username, password });

    if (data) {
      const normalizedToken = {
        access_token: data.accessToken,
        ".expires": new Date(Date.now() + data.expiresInSeconds * 1000).toISOString(),
        userName: data.userName,
      };
      setToken(normalizedToken);

      setUser(data.userName);
      localStorage.setItem("accountNumber", data.customerNumber);
      localStorage.setItem("username", data.userName);
      if (data.internalAccount) {
        localStorage.setItem("internalAccount", true);
      }

      navigate(`${AppConfig.orderFormPath}/`);
    }
  };

  return (
    <>
      <div className="">
        <div className="login">
          <div className="loginImg">
            <img src={logo} alt="logo" className="siteLogo" />
          </div>
          <div className="formContainer filedWidth">
            <form className="form" onSubmit={handleSubmit}>
              <div className="formTitle">
                <h2>Sign In</h2>
                <p>
                  
                </p>
              </div>
              {showInvalid && (
                <div className="alert">
                  <Alert severity="error" key="invalidValues">
                    Invalid email or password
                  </Alert>
                </div>
              )}
              {showLoginFailure && (
                <Alert key="loginFailed" severity="error">
                  {authError}
                </Alert>
              )}

              <div className="fields">
                <InputTextField
                  label="Username"
                  variant="outlined"
                  placeholder="Username or Email"
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUserName(e.target.value)}
                />

                <InputTextField
                  label="Password"
                  variant="outlined"
                  placeholder="Enter your password"
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              <div className="forgetPassword">
                <Link
                  to={Config.gatewayAccountUrl+"ForgotPassword"}
                >
                  <span> Forgot Password?</span>
                </Link>
              </div>

              <Button text="Login" type="submit" width="true" />

              <div className="register">
                <p>Don’t have an account?</p>
                <Link
                  to={Config.gatewayAccountUrl+"Register"}
                  className="registerText"
                >
                  <span> Register Now</span>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );

  async function loginUser(credentials) {
    try {
      const res = await securityApiClient.post(
        "api/auth/login",
        { UserName: credentials.username, Password: credentials.password }
      );
      return res.data;
    } catch (error) {
      if (error.response?.status === 401) {
        setAuthError("Invalid username or password.");
      } else {
        setAuthError("Login failed. Please try again.");
      }
      setShowLoginFailure(true);
      return null;
    }
  }
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired,
};
